module.exports = __webpack_public_path__ + "static/img/reward2-shadowed.54aabd4b.png";